"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuickReplies = void 0;
var react_1 = __importStar(require("react"));
var Keyboard = __importStar(require("../../Keyboard"));
var Button_1 = require("./Button");
/**
 * Displays an array of button, and handle when they are clicked
 *
 * @param {object} buttons The list of buttons to display (object with a label and a payload)
 * @param {function} onSendData Called with the required payload to answer the quick reply
 * @param {function} onFileUpload This is called when a file is uploaded
 *
 * @return onSendData is called with the reply
 */
var QuickReplies = /** @class */ (function (_super) {
    __extends(QuickReplies, _super);
    function QuickReplies() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleButtonClicked = function (title, payload) {
            var _a, _b;
            _this.props.store.view.setFocus('button');
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            (_b = (_a = _this.props).onSendData) === null || _b === void 0 ? void 0 : _b.call(_a, {
                type: 'quick_reply',
                text: title,
                payload: payload
            });
            _this.props.store.composer.setLocked(false);
            // Set focus back to composer input
            _this.props.store.view.setFocus('input');
        };
        return _this;
    }
    QuickReplies.prototype.renderKeyboard = function (buttons) {
        var _this = this;
        return buttons.map(function (btn, idx) {
            if (Array.isArray(btn)) {
                return react_1.default.createElement("div", null, _this.renderKeyboard(btn));
            }
            else {
                return (react_1.default.createElement(Button_1.Button, { key: idx, label: btn.label || btn.title, payload: btn.payload, preventDoubleClick: !btn.allowMultipleClick, onButtonClick: _this.handleButtonClicked, onFileUpload: _this.props.onFileUpload }));
            }
        });
    };
    QuickReplies.prototype.render = function () {
        var buttons = this.props.buttons || this.props.quick_replies;
        var kbd = (react_1.default.createElement("div", { className: this.props.displayInMessage ? 'bpw-in-message-quick_reply' : 'bpw-keyboard-quick_reply' }, buttons && this.renderKeyboard(buttons)));
        var visible = this.props.isLastGroup && this.props.isLastOfGroup;
        if (this.props.displayInMessage && visible) {
            return (react_1.default.createElement("div", null,
                this.props.children,
                kbd));
        }
        return (react_1.default.createElement(Keyboard.Prepend, { keyboard: kbd, visible: visible }, this.props.children));
    };
    return QuickReplies;
}(react_1.Component));
exports.QuickReplies = QuickReplies;
